<template>
    <div class="news">
        <div class="list" v-loading="isDataLoading">
            
            <router-link
                class="card"
                v-for="item in news"
                :key="item.id"
                :to="{ name: 'news', params: {
                    page: 1,
                    id: item.id,
                }}"
                target='_blank'
            >
                <img :src="item.preview" :alt="item.title" class="preview">
                <div class="text">
                    <span class="date">{{ item.createdAt | timestampFullDate}}</span>
                    <div class="title">{{ item.title }}</div>
                </div>
            </router-link>
        </div>
        <Button
            v-if="getNewsCount && getNewsCount > news.length"
            class="more_btn"
            @click="loadMoreHandler"
        >Показать еще</Button>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Button from '@/components/UI/Button';

const newsActions = [
    'fetchNews',
];

const newsGetters = [
    'getNewsCount',
];

export default {
    name: 'News',
    components: {
        Button,
    },
    data: () => ({
        isDataLoading: false,
        news: [],
        page: 1,
        limit: 6,
    }),
    computed: {
        ...mapGetters('mentoring/news', newsGetters),
    },
    created() {
        this.loadNews();
    },
    methods: {
        loadMoreHandler() {
            if (this.getNewsCount <= this.news.length) return;

            this.page++;
            this.loadNews();
        },
        async loadNews() {
            this.isDataLoading = true;

            const news = await this.fetchNews({
                limit: this.limit,
                offset: this.limit * (this.page - 1),
            });

            this.news = this.news.concat(news);

            this.isDataLoading = false;
        },
        ...mapActions('mentoring/news', newsActions),
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import '@/styles/rem';
@import '@/styles/mrem';

.news{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .list{
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: rem(8);
        width: 100%;
        @include on-mobile{
            flex-direction: column;
            align-items: stretch;
        }
        .preloader{
            position: absolute;
            z-index: 999;
            background-color: rgba(255, 255, 255, 0.9);
        }
        .card{
            display: flex;
            flex-direction: column;
            width: rem(333);
            overflow: hidden;
            border: rem(1) solid #C7C7C7;
            border-radius: rem(4);
            margin-bottom: rem(24);
            user-select: none;
            cursor: pointer;
            text-decoration: none;
            @include on-mobile{
                width: 100%;
                border-radius: mrem(4);
                margin-bottom: mrem(24);
            }
            .preview{
                width: 100%;
                @include on-mobile{
                    height: mrem(194);
                }
            }
            .text{
                display: flex;
                flex-direction: column;
                padding: rem(16);
                @include on-mobile{
                    padding: mrem(16);
                }
                .date{
                    font-weight: 600;
                    font-size: rem(14);
                    line-height: rem(20);
                    color: #98A0A9;
                    margin-bottom: rem(8);
                    @include on-mobile{
                        font-size: mrem(14);
                        line-height: mrem(20);
                        margin-bottom: mrem(8);
                    }
                }
                .title{
                    font-weight: 600;
                    font-size: rem(16);
                    line-height: rem(24);
                    color: #000000;
                    height: rem(120);
                    overflow: hidden;
                    @include on-mobile{
                        font-size: mrem(16);
                        line-height: mrem(24);
                        height: mrem(120);
                    }
                }
            }
        }
    }
    .more_btn{
        padding: 0 rem(32);
        @include on-mobile{
            padding: auto;
            width: 100%;
        }
    }
}
</style>